import { Type } from '../../../../general/modules/filter/dataModel';
import { GenreCellInner } from '../components/cells/GenreCell';
import { WithLoader } from '../components/cells/WithLoader';
import { FilterGenresContainer } from '../components/plugins/filters/FilterGenresContainer';
import { Column, FMColumn } from '../model';

export const genreCol: FMColumn<Type.ID> = {
  key: Column.genre,
  dataKey: Column.genre,
  title: 'Genre',
  width: 125,
  sortable: true,
  cellRenderer: WithLoader(GenreCellInner),
  className: 'ch-file-manager__cell_genre',
  plugins: [FilterGenresContainer],
  filter: Type.ID,
  // getter/toDisplayString оставляем скалярными: возвращаем первый выбранный
  // жанр (сортировка по колонке работает по одиночному id; для отображения
  // используется GenreCellInner, где выводятся все жанры через запятую).
  // Fallback на старое поле `genre`.
  getter: (row) => {
    const genres = row.creative?.genres;
    if (genres && genres.length > 0) return genres[0].id;
    return row.creative?.genre?.id ?? null;
  },
  // Для фильтрации (пересечение массива жанров креатива с выбранным набором)
  // используется `multiGetter` — см. `getNodesFiltered` в `selectors2.ts`.
  multiGetter: (row) => {
    const genres = row.creative?.genres;
    if (genres && genres.length > 0) return genres.map((g) => g.id);
    const single = row.creative?.genre?.id;
    return single !== undefined && single !== null ? [single] : [];
  },
  toDisplayString: (row) => {
    const genres = row.creative?.genres;
    if (genres && genres.length > 0) return genres.map((g) => g.name).join(', ');
    return row.creative?.genre?.name ?? null;
  },
};
